var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Assign',{ref:"AssignRef"}),_c('el-row',{staticClass:"border_top",attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":14}},[_c('AssignForm',{ref:"AssignFormRef",on:{"validate":_vm.validate}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }